import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=d20c9d0c"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/auth.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./Register.vue?vue&type=style&index=1&id=d20c9d0c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports